import styled from 'styled-components';

export const SC_Text = styled.p`
    font-size: 12px !important;
    margin: 0!important;
    line-height: 18px;
    padding: 4px;
`

export const SC_TooltipHardware = styled.div`
    p {        
        color: var(--dim-gray);
    }

    .link{
        color: var(--chateau-green);
        cursor: pointer;
        font-weight: bold;
    }
`